export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_BUDGET_LINES: 'SET_BUDGET_LINES',
    SET_SELECTED_BUDGET_LINE: 'SET_SELECTED_BUDGET_LINE',
    ADD_BUDGET_LINE: 'ADD_BUDGET_LINE',
    UPDATE_BUDGET_LINE: 'UPDATE_BUDGET_LINE',
    DELETE_BUDGET_LINE: 'DELETE_BUDGET_LINE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    budgetLines: [],
    selectedBudgetLine: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const budgetLineReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return { ...state, loading: action.payload };

        case ACTIONS.SET_ERROR:
            return { ...state, error: action.payload, loading: false };

        case ACTIONS.CLEAR_ERROR:
            return { ...state, error: null };

        case ACTIONS.SET_BUDGET_LINES:
            return {
                ...state,
                budgetLines: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_BUDGET_LINE:
            return { ...state, selectedBudgetLine: action.payload, loading: false };

        case ACTIONS.ADD_BUDGET_LINE:
            return {
                ...state,
                budgetLines: [action.payload, ...state.budgetLines],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_BUDGET_LINE:
            return {
                ...state,
                budgetLines: state.budgetLines.map((budgetLine) =>
                    budgetLine.id === action.payload.id ? action.payload.data : budgetLine
                ),
                selectedBudgetLine: state.selectedBudgetLine?.id === action.payload.id ? action.payload.data : state.selectedBudgetLine,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_BUDGET_LINE:
            return {
                ...state,
                budgetLines: state.budgetLines.filter((budgetLine) => budgetLine.id !== action.payload),
                selectedBudgetLine: state.selectedBudgetLine?.id === action.payload ? null : state.selectedBudgetLine,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
